export enum UserState {
  UNLOADED,
  NOT_AUTHENTICATED,
  SIGNIN,
  SIGNOUT,
}

export interface AuthState {
  authenticated: boolean;
  error?: string;
  status: UserState;
  kcReady: boolean;
  fetchedLoginGql?: boolean;
}

export const initialState: AuthState = {
  status: UserState.UNLOADED,
  authenticated: false,
  kcReady: false,
  fetchedLoginGql: false,
};

export type RootState = { auth: AuthState };
